import React, { useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop'
import getCroppedImg from './CropImage';

import {
  Dialog, DialogTitle, IconButton, DialogContent, DialogActions,
} from '@mui/material';

import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import RotateRight from '@mui/icons-material/RotateRight';
import RotateLeft from '@mui/icons-material/RotateLeft';
import ZoomIn from '@mui/icons-material/ZoomIn';
import ZoomOut from '@mui/icons-material/ZoomOut';

export default function ModalAvatarEmployee(props) {
  const { onClose, selectedFile, open, title } = props;

  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImageFile = await getCroppedImg(
        selectedFile,
        croppedAreaPixels,
        rotation
      )
      console.log('donee', { croppedImageFile })

      setCroppedImage(croppedImageFile)
      onClose(croppedImageFile);
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation])

  const handleClose = () => {
    setCroppedImage(null);
    onClose(null);
  };

  const handleRotateChange = (value) => {
    setRotation(prevState => prevState + value);
  }
  const handleZoomChange = (value) => {
    setZoom(prevState => prevState + value);
  }

  return (
    <Dialog
      maxWidth='md'
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
      <DialogContent style={styles.content}>
        <div style={styles.container}>
          <Cropper
            image={selectedFile && selectedFile.preview}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          // cropShape="round"
          />
        </div>
        <div style={styles.buttonContainer}>
          <IconButton onClick={() => handleRotateChange(+90)} size="large"><RotateRight /></IconButton>
          <IconButton onClick={() => handleRotateChange(-90)} size="large"><RotateLeft /></IconButton>
          <IconButton onClick={() => handleZoomChange(+0.1)} size="large"><ZoomIn /></IconButton>
          <IconButton onClick={() => handleZoomChange(-0.1)} size="large"><ZoomOut /></IconButton>
        </div>
      </DialogContent>

      <DialogActions>
        <div style={styles.submitButtonsContainer}>
          <IconButton onClick={handleClose} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
          <IconButton onClick={showCroppedImage} size="large"><DoneIcon fontSize='large' style={styles.doneIcon} /></IconButton>
        </div>
      </DialogActions>

    </Dialog>
  );
}

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 20px',
  },
  container: {
    position: 'relative',
    width: '100%',
    background: '#fff',
    width: 400,
    height: 400,
  },
  buttonContainer: {
    marginTop: 10,
  },
  submitButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  doneIcon: {
    color: 'green',
  }
}